<script lang="ts">
	import { browser } from '$app/environment';
	import { page } from '$app/stores';
	import { fly } from 'svelte/transition';
	import { bodyScrollHandler } from '$lib/utils/common';

	export let id = '';

	$: if (browser) {
		if ($page.state.showSlideDownModal) {
			bodyScrollHandler(false);
		} else {
			bodyScrollHandler(true);
		}
	}
</script>

{#if $page.state.showSlideDownModal && $page.state.showSlideDownModal[id]}
	<div
		class="fixed inset-0 z-40 flex items-start justify-center bg-black/60"
		on:click|self={() => history.back()}
		role="button"
		tabindex="0"
		on:keydown
	>
		<div class="w-full rounded-b-[20px] bg-white" transition:fly={{ y: -200, duration: 400 }}>
			<div class="pt-[80px]">
				<slot name="content" />
			</div>
			<div class="flex gap-4 px-6 pb-6">
				<slot name="actions" />
			</div>
		</div>
	</div>
{/if}

<style>
	::-webkit-scrollbar {
		all: unset;
	}
</style>
